import WR360 from './build/js/imagerotator.js';
export default WR360;